import { render, staticRenderFns } from "./ProductsMobile.vue?vue&type=template&id=1b737b4e&scoped=true"
import script from "./ProductsMobile.vue?vue&type=script&lang=js"
export * from "./ProductsMobile.vue?vue&type=script&lang=js"
import style0 from "./ProductsMobile.vue?vue&type=style&index=0&id=1b737b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b737b4e",
  null
  
)

export default component.exports